import { render } from "./payment-info-link.vue?vue&type=template&id=07ffe6c6"
import script from "./payment-info-link.vue?vue&type=script&lang=js"
export * from "./payment-info-link.vue?vue&type=script&lang=js"

import exportComponent from "/builds/commerce/central/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__